import React from 'react';
import './SessionStatusPage.css';

/**
 * [WTD-1826] The page shown when a session cannot be used, whatever the reason.
 *
 * One component for both states because they differ only in their words, and having them differ in
 * anything else is how they drifted apart in the first place - across three applications this page
 * had three spellings of the company and two capitalisations of the same title. The words come from
 * web-connect-service so BoneVue and Autometrics say exactly the same thing.
 */
const SessionStatusPage: React.FC<{ title: string; message: string }> = ({ title, message }) => (
  <div className="session-status">
    <h1>{title}</h1>
    <p>{message}</p>
  </div>
);

export default SessionStatusPage;
